import { Component } from 'preact';
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import BoxTerminal from "../../../components/shared/BoxTerminal";
import Interpret from "../../../components/shared/Localization/Interpret";
import ButtonsConstructor from "../../../components/shared/Input/Button/ButtonsConstructor";
import { sessionServices } from "../../../services/session-services";
import { route } from "preact-router";
import { E_Route } from "../../../models/constants/Enum_Routes";
import MessageModal from "../../../components/shared/Modal/MessageModal";

class DeliveryWizardSummary extends Component {
	constructor(props) {
		super();

		this.state = {
			sending: false,
		}
	}

	render({className, style, partner, serviceType, user, customUserEmail}, {sending}) {
		return (
			<section className={combineClasses("delivery-wizard-summary", className)} style={style}>
				<BoxTerminal
					title={"box.deliverPackage"}
					contentHeaderSlot={
						<div className={"title"}>
							<Interpret id={"summary"}/>
						</div>
					}
					contentSlot={
						<div>
							{
								partner &&
								<>
									<h2><Interpret id={"deliveryWizard.summary.partner"}/></h2>
									<p>{partner.name}</p>
								</>
							}

							<h2><Interpret id={"deliveryWizard.summary.user"}/></h2>
							<p>{user?.name ?? customUserEmail ?? '-'}</p>

							<h2><Interpret id={"deliveryWizard.summary.serviceType"}/></h2>
							<p>{serviceType?.titles ? <Interpret id={serviceType?.titles}/> : '-'}</p>
						</div>
					}
					contentRightSlot={
						<ButtonsConstructor buttons={[
							{
								className: "submit-button",
								text: "deliver",
								action: () => this._submit(),
								disabled: sending,
								spinner: sending,
							}
						]}/>
					}
				/>
			</section>
		);
	}

	_submit() {
		const {locationID, unitID, partner, serviceType, user, customUserEmail} = this.props;

		this.setState({sending: true});
		sessionServices.submitDelivery({
			locationID,
			unitID,
			partnerID: partner?.id,
			serviceTypeID: serviceType.id,
			userID: user?.id,
			email: customUserEmail ?? undefined,
		}).then(() => {
			window.modal.open(
				<MessageModal
					title={"deliveryWizard.completed"}
				/>,
			);

			route(E_Route.BASE);
		}, () => {
			this.setState({sending: false});

			window.toaster.showToast({
				icon: "truck-loading",
				title: "deliveryWizard.summary.submit.error.title",
				lifespan: "10s",
				accent: "error",
			});
		});
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			locationID: PropTypes.number.isRequired,
			unitID: PropTypes.number.isRequired,

			partner: PropTypes.object,
			serviceType: PropTypes.object,
			user: PropTypes.object,
			customUserEmail: PropTypes.string,
		}
	}
}

export default DeliveryWizardSummary;
